import { useQuery } from "@tanstack/react-query";
import { fetchWithAuth } from "@/utils/fetchWithAuth";
import { API_BASE_URL } from "@/api/helpers";
import type { Room } from "@/types/Room";

export function useOrderedRooms(locationSlug: string | undefined) {
  return useQuery({
    queryKey: ["orderedRooms", locationSlug],
    queryFn: async (): Promise<Room[]> => {
      if (!locationSlug) return [];

      const response = await fetchWithAuth(
        `${API_BASE_URL}/api/rooms/location/${locationSlug}/ordered`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch ordered rooms");
      }

      const data = await response.json();
      return data.rooms || [];
    },
    enabled: !!locationSlug,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
